module.exports = __webpack_public_path__ + "static/media/BPCL.aa616588.txt";